
import React, { useState } from 'react';
import './ProductCard.css';
import { Product, useApp } from '../../context/AppContext';

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const { setSelectedProduct, toggleWishlist, currentUser, addToCart } = useApp();
  const [addedToCart, setAddedToCart] = useState(false);
  const isWishlisted = currentUser.wishlist.includes(product.id);
  const isOnSale = product.salePrice && product.salePrice < product.price;
  const isLowStock = product.stock <= 10;

  const handleQuickAdd = (e: React.MouseEvent) => {
    e.stopPropagation();
    const defaultSize = product.sizes.find(s => s.stock > 0)?.size || product.sizes[0].size;
    addToCart(product.id, defaultSize, 1);
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
  };

  return (
    <div className="product-card animate-scale-in" onClick={() => setSelectedProduct(product)}>
      <div className="product-image">
        <img src={product.images[0]} alt={product.name} />
        {isOnSale && <span className="sale-badge">SALE</span>}
        {isLowStock && <span className="stock-badge">Low Stock</span>}
        <button 
          className={`wishlist-btn ${isWishlisted ? 'active' : ''}`}
          onClick={(e) => { e.stopPropagation(); toggleWishlist(product.id); }}
        >
          <svg viewBox="0 0 24 24" fill={isWishlisted ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
          </svg>
        </button>
        <button 
          className={`quick-add-btn ${addedToCart ? 'added' : ''}`}
          onClick={handleQuickAdd}
        >
          {addedToCart ? (
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          )}
        </button>
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <div className="product-meta">
          <div className="product-rating">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <span>{product.rating}</span>
            <span className="review-count">({product.reviews})</span>
          </div>
        </div>
        <div className="product-price">
          {isOnSale ? (
            <>
              <span className="sale-price">${product.salePrice?.toFixed(2)}</span>
              <span className="original-price">${product.price.toFixed(2)}</span>
            </>
          ) : (
            <span className="current-price">${product.price.toFixed(2)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
